var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mock",style:({ 'background-color': _vm.background, opacity: 0.8 })},[_c('div',{staticClass:"mock__text"},[_c('pre',[_vm._v(_vm._s(_vm.config.text || 'Espace disponible'))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }